export enum LoadingSize {
  SM = 'sm',
  LG = 'lg'
}

export enum LoadingSpacing {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  NONE = 'none'
}

export enum LoadingTheme {
  DARK = 'dark',
  LIGHT = 'light'
}

export enum LoadingVariant {
  DOT = 'dot',
  LINEAR = 'linear'
}
